module.exports = __webpack_public_path__ + "media/images/vehicles/betonmischer-de3d32462b6c01f31f7b9305b6ac8986.png";